import React from "react";

export default function QualityCheckQuestion(props) {
  const questionId = `question_${props.question.id}`;

  return (
    <div>
      <ul className="hidden-xs">
        <li
          onFocus={() => props.onMouseOver(props.question.id)}
          onMouseOver={() => props.onMouseOver(props.question.id)}
          name={questionId}
        >
          {props.question.question}
        </li>
      </ul>

      <div className="visible-xs-inline">
        <ul>
          <li>{props.question.question}</li>
        </ul>
      </div>
    </div>
  );
}
